module.exports = __webpack_public_path__ + "static/media/resume.d41d8cd9.pdf";